__turbopack_context__.v({
  "root": "ChartPlaceholder-module__xSbbaW__root",
});
